import { Dashboard, PaymentInformation } from '@/components';

export const PaymentInformationPage = (): JSX.Element => (
  <Dashboard>
    <PaymentInformation />
  </Dashboard>
);
